import { render, staticRenderFns } from "./addCustomer.vue?vue&type=template&id=b37b1ff2&scoped=true"
import script from "./addCustomer.vue?vue&type=script&lang=js"
export * from "./addCustomer.vue?vue&type=script&lang=js"
import style0 from "./addCustomer.vue?vue&type=style&index=0&id=b37b1ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37b1ff2",
  null
  
)

export default component.exports